import { Autocomplete, Card, Grid } from "@mui/material";
import CardItem from "components/alove/CardItem";
import ItemPageContainer from "layouts/itemPageContainer";
import { BoSettingsPage, BoSettingsPageSettings } from "models/BO/BoSettingsPage";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  createBoSettingsPageDO,
  deleteBoSettingsPageDO,
  getBoSettingsPage,
  saveBoSettingsPageDO,
} from "utils/boSettingsPageUtils";
import { useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { PageNumber } from "accessNumbers";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { getGeneralCodes } from "utils/generalCodesUtils";
import { EditSettingsPanel } from "./components/EditSettingsPanel";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;
const MDInput = require("components/MDInput").default;
const MDButton = require("components/MDButton").default;
export const BoSettingsPagesView = () => {
  const pageNumber = PageNumber.ViewInfoScreen;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = controller;
  const [boSettingsPage, setBoSettingsPage] = useState({
    settings: [] as BoSettingsPageSettings[],
  } as BoSettingsPage);
  const { id } = useParams();

  useEffect(() => {
    if (id && id !== "new") {
      getBoSettingsPage(id).then((boSettingsPage) => setBoSettingsPageObject(boSettingsPage));
    }
  }, [id]);

  const setBoSettingsPageObject = (newBoSettingsPage) => {
    newBoSettingsPage.settings ||= [];
    setBoSettingsPage(Object.assign(new BoSettingsPage(), newBoSettingsPage));
  };

  const saveBoSettingsPage = async () =>
    id === "new"
      ? createBoSettingsPageDO(boSettingsPage).then((boSettingsPage) => navigate(-1))
      : saveBoSettingsPageDO(boSettingsPage);

  const deleteBoSettingsPage = async () =>
    deleteBoSettingsPageDO(boSettingsPage).then(() => navigate(-1));

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={boSettingsPage.title || "New Settings Page"} />
      <ItemPageContainer
        navItems={[
          { label: "Settings Page settings", ref: "settings" },
          { label: "Edit Settings Page", ref: "boSettingsPage" },
          { label: "Workflow", ref: "workflow" },
        ]}
        actions={{
          actionsTitle: "Settings Page actions",
          itemName: `Information Settings Page`,
          itemNumber: `#${boSettingsPage.id}`,
          actions: [
            {
              title: "Save",
              onClick: saveBoSettingsPage,
              variant: "contained",
            },
          ],
        }}
        itemStatus={{
          title: "Settings Page status",
          item: boSettingsPage,
          isManager: true,
          changeStatus: async (newStatus) => {
            boSettingsPage.statusId = newStatus;
            setBoSettingsPageObject({ ...boSettingsPage });
            await saveBoSettingsPage();
          },
        }}
        itemHeader={
          <CardItem title="Edit Settings Page" id="boSettingsPage">
            <Grid container spacing={2}>
              <Grid size={6}>
                <MDInput
                  label="Page Title"
                  value={boSettingsPage.title || ""}
                  fullWidth
                  onChange={(e) =>
                    setBoSettingsPageObject({ ...boSettingsPage, title: e.target.value })
                  }
                />
              </Grid>
              <Grid size={6}>
                <MDButton
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    setBoSettingsPageObject({
                      ...boSettingsPage,
                      settings: [
                        ...boSettingsPage.settings,
                        { title: "", settings: [], publishKey: "" },
                      ],
                    })
                  }
                >
                  Add Setting
                </MDButton>
              </Grid>
            </Grid>
          </CardItem>
        }
        deleteItem={{
          buttonText: "Delete Settings Page",
          contetnText: "Are you sure you want to delete this settings page?",
          hidden: !currentRole.hasAccess(pageNumber, PermissionType.Delete),
          onDelete: deleteBoSettingsPage,
        }}
      >
        {boSettingsPage.settings.map((settingPanel, index) => (
          <CardItem
            title={`Setting Panel ${index + 1}`}
            key={index}
            id={`settingPanel${index}`}
            buttons={[
              <MDButton
                variant="outlined"
                color="error"
                onClick={() => {
                  const newSettings = [...boSettingsPage.settings];
                  newSettings.splice(index, 1);
                  setBoSettingsPageObject({ ...boSettingsPage, settings: newSettings });
                }}
              >
                Delete Panel
              </MDButton>,
            ]}
          >
            <EditSettingsPanel
              key={index}
              settingPanel={settingPanel}
              setSettingPanel={(panel) => {
                const newSettings = [...boSettingsPage.settings];
                newSettings[index] = panel;
                setBoSettingsPageObject({ ...boSettingsPage, settings: newSettings });
              }}
            />
          </CardItem>
        ))}
      </ItemPageContainer>
    </DashboardLayout>
  );
};
